'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002472 from "./presto.types$-Group-Name$$anon$72.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002473 from "./presto.types$-Group-Name$$anon$73.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupName$() {
  this.c6p = null;
  this.c6q = false;
  this.c6n = null;
  this.c6o = false;
  this.c6t = null;
  this.c6u = false;
  this.c6r = null;
  this.c6s = false;
  this.c6v = null;
  this.c6w = false;
}
export { $c_Lpresto_types$GroupName$ as $c_Lpresto_types$GroupName$ };
$p = $c_Lpresto_types$GroupName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupName$;
/** @constructor */
function $h_Lpresto_types$GroupName$() {
}
export { $h_Lpresto_types$GroupName$ as $h_Lpresto_types$GroupName$ };
$h_Lpresto_types$GroupName$.prototype = $p;
$p.adl = (function() {
  if ((!this.c6q)) {
    this.c6p = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c6q = true;
  }
  return this.c6p;
});
$p.mf = (function() {
  if ((!this.c6o)) {
    this.c6n = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c6o = true;
  }
  return this.c6n;
});
$p.crN = (function() {
  if ((!this.c6u)) {
    this.c6t = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c6u = true;
  }
  return this.c6t;
});
$p.SB = (function() {
  if ((!this.c6s)) {
    this.c6r = new $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002472.$c_Lpresto_types$GroupName$$anon$72(this);
    this.c6s = true;
  }
  return this.c6r;
});
$p.cIt = (function() {
  if ((!this.c6w)) {
    this.c6v = new $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002473.$c_Lpresto_types$GroupName$$anon$73(this);
    this.c6w = true;
  }
  return this.c6v;
});
var $d_Lpresto_types$GroupName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupName$, "presto.types$GroupName$", ({
  a0x: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupName$ as $d_Lpresto_types$GroupName$ };
var $n_Lpresto_types$GroupName$;
function $m_Lpresto_types$GroupName$() {
  if ((!$n_Lpresto_types$GroupName$)) {
    $n_Lpresto_types$GroupName$ = new $c_Lpresto_types$GroupName$();
  }
  return $n_Lpresto_types$GroupName$;
}
export { $m_Lpresto_types$GroupName$ as $m_Lpresto_types$GroupName$ };
//# sourceMappingURL=presto.types$-Group-Name$.js.map
